export default "__VITE_ASSET__DicAbrMi__"